import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWorkspaceBilling } from './state_workspace_billing';

export const local_workspace_billing_subscriptions_delete = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.WORKSPACE_BILLING_SUBSCRIPTIONS_DELETE,
  payload: payload,
});

export const init_local_workspace_billing_subscriptions_delete = (state: StateWorkspaceBilling, action: PayloadAction<string[]>) => {
  if (action.payload.is_empty()) return;

  for (let id of action.payload) {
    state.subscriptions_map.delete(id);
  }

  //need to force a re-render
  state.subscriptions_map = new Map(state.subscriptions_map);
};
